import React, { useState } from 'react';
import styled from 'styled-components';

import axios from '../../axios';
import Button from '../UI/button';

//#region Styled Components
const Container = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

const ListInput = styled.input`
  border: 1px solid var(--border-main);
  border-radius: 5px;
  width: 100%;
  font-size: 0.75rem;
  margin-right: 1rem;
  padding: 0.5rem;
  box-shadow: none;
  outline: none;
  transition: border-color 0.15s ease;

  &:hover,
  &:focus,
  &:active {
    border-color: var(--border-hover);
  }
`;
//#endregion

const AddList = ({ addNewList }) => {
  const [newListName, setNewListName] = useState('');

  const keyPressHandler = async e => {
    if (e.which === 13) {
      e.preventDefault();
      await addList(newListName);
    }
  };

  const addList = async name => {
    const listData = {
      name: `${name}`,
    };

    try {
      const response = await axios.post('/lists.json', listData);
      const newList = {
        ...listData,
        id: response.data.name,
      };
      addNewList(newList);
      setNewListName('');
    } catch (error) {
      throw error;
    }
  };

  return (
    <Container>
      <ListInput
        value={newListName}
        onChange={e => setNewListName(e.target.value)}
        onKeyPress={keyPressHandler}
        tabIndex="3"
      />
      <Button onClick={() => addList(newListName)} tabIndex="4">
        Add List
      </Button>
    </Container>
  );
};

export default AddList;
